// third party
import { combineReducers } from 'redux';

// project imports
import snackbarReducer from './slices/snackbar';
import companyReducer from './slices/company';
import userReducer from './slices/user';
import userConfigReducer from './slices/userConfig';
import companyPlatformsReducer from './slices/companyPlatforms';
import templatesReducer from './slices/templates';
import labelsReducer from './slices/labels';
import appUsersReducer from './slices/applicationUsers';
import kanbanReducer from './slices/kanban';
import calendarReducer from './slices/calendar';
import chatReducer from './slices/chat';
import appSidebarReducer from './slices/app-sidebar';
import dualSidebarReducer from './slices/dual-sidebar';
import UnreadChatUsersReducer from './slices/unread-chat-users';
import viewCountsReducer from './slices/status-unread-counts';
import PriorityReducer from './slices/priority';
import massMessagingReducer from './slices/mass-messaging';
import simpleTemplatesReducer from './slices/simple-templates';
import systemNotificationsReducer from './slices/system-notifications';
import globalStatusReducer from './slices/global-status';
import templateWatcherReducer from './slices/template-watcher';
import accountModulesReducer from './slices/accountModules';
import contactTagsReducer from './slices/contactTags';
// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  globalStatus: globalStatusReducer,
  templateWatcher: templateWatcherReducer,
  snackbar: snackbarReducer,
  company: companyReducer,
  user: userReducer,
  userConfig: userConfigReducer,
  companyPlatforms: companyPlatformsReducer,
  templates: templatesReducer,
  simpleTemplates: simpleTemplatesReducer,
  labels: labelsReducer,
  applicationUsers: appUsersReducer,
  kanban: kanbanReducer,
  calendar: calendarReducer,
  chat: chatReducer,
  appSidebar: appSidebarReducer,
  dualSidebar: dualSidebarReducer,
  unreadChatUsers: UnreadChatUsersReducer,
  viewCounts: viewCountsReducer,
  priority: PriorityReducer,
  massMessaging: massMessagingReducer,
  systemNotifications: systemNotificationsReducer,
  accountModules: accountModulesReducer,
  contactTags: contactTagsReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET_STORE') {
    state = undefined;
  }
  return reducer(state, action);
};

export default rootReducer;
